import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {
    FileAttachment,
    FileAttachmentsV1Service,
    Employee,
    EmployeesV1Service
} from "../../../apis/backend";
import {firstValueFrom, mergeMap} from "rxjs";
import {
    EmployeeDialogComponent,
} from "../dialog/employee-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileAttachmentComponent} from "../../../components/file-attachments/file-attachment/file-attachment.component";

@Component({
    selector: 'employee',
    templateUrl: './employee-detail.component.html',
})
export class EmployeeDetailComponent implements OnInit {
    
    public Employee: Employee;
    
    public EditMode = false;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service,
                private _employeeService: EmployeesV1Service,
                private _modalService: NgbModal,
                private _route: ActivatedRoute) {}
    
    ngOnInit() {
        this._route.params.pipe(
            mergeMap(params => {
                return this._employeeService.getEmployee(params['employeeID']);
            })
        )
            .subscribe(employee => {
                this.Employee = employee;
            });
    }

    public EditEmployee() {
        if (this.Employee) {
            let employee = <Employee>JSON.parse(JSON.stringify(this.Employee));

            let modal = this._modalService.open(EmployeeDialogComponent, { size: 'lg' });
            modal.componentInstance.Employee = employee;

            modal.result
                .then((employee: Employee) => {
                    return firstValueFrom(this._employeeService.updateEmployee(employee.EmployeeID, employee));
                })
                .then((employee: Employee) => {
                    this.Employee = employee;
                });
        }
    }

    // public InsuranceCardUploader() {
    //     return (file: File) => {
    //         return firstValueFrom(this._employeeService.apiV1EmployeesEmployeeIDInsuranceCardPost(
    //             this.Employee.EmployeeID,
    //             file));
    //     }
    // }
    //
    // public InsuranceCardDeleter() {
    //     return () => {
    //         return firstValueFrom(this._employeeService.apiV1EmployeesEmployeeIDInsuranceCardDelete(
    //             this.Employee.EmployeeID));
    //     }
    // }

    public FileUploader() {
        return (file: File) => {
            return firstValueFrom(this._employeeService.uploadFileAttachment(
                this.Employee.EmployeeID,
                file));
        }
    }

    public FileDeleter() {
        return (fileAttachment: FileAttachment) => {
            return firstValueFrom(this._employeeService.deleteFileAttachment(
                this.Employee.EmployeeID,
                fileAttachment.FileAttachmentID));
        }
    }
}